import { runDemo } from "../shared/demoRunner";
import { createAssetsManagerScene } from "./scene";

runDemo({
    createScene: createAssetsManagerScene,
});
